export default "__VITE_ASSET__CTGVCRxn__"